import useSWR from 'swr';

import { getMerchant } from '../firebase/firestore/merchants';

export const useMerchant = (storeID: string) => {
  const { data, error, mutate } = useSWR(`/merchant/${storeID}`, () => getMerchant(storeID));

  return {
    merchant: data,
    isLoading: !error && !data,
    error,
    mutate
  };
};
